/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { AgroClimaticZone } from '../../models/agro-climatic-zone';

export interface GetAgroClimaticZones$Params {
   /**
    * Decide active or not climatic zone
    */
   active?: boolean;
}

export function getAgroClimaticZones(
   http: HttpClient,
   rootUrl: string,
   params?: GetAgroClimaticZones$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<AgroClimaticZone>> {
   const rb = new RequestBuilder(rootUrl, getAgroClimaticZones.PATH, 'get');
   if (params) {
      rb.query('active', params.active, {});
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<AgroClimaticZone>;
      })
   );
}

getAgroClimaticZones.PATH = '/api/weather/agro/climatic/zone';
